var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1514_3090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3963 2.98947C25.4842 2.06863 23.4337 1.3902 21.2899 1.00163C21.2508 0.994131 21.2118 1.01287 21.1917 1.05035C20.928 1.54262 20.6359 2.18482 20.4314 2.68959C18.1255 2.32727 15.8315 2.32727 13.5729 2.68959C13.3683 2.1736 13.0656 1.54262 12.8007 1.05035C12.7806 1.01412 12.7416 0.995381 12.7026 1.00163C10.5599 1.38896 8.50945 2.06739 6.59617 2.98947C6.57961 2.99696 6.56541 3.00947 6.55599 3.0257C2.66674 9.12415 1.60131 15.0727 2.12398 20.9475C2.12634 20.9762 2.14171 21.0037 2.163 21.0212C4.72901 22.999 7.21463 24.1998 9.6541 24.9956C9.69314 25.0081 9.73451 24.9931 9.75935 24.9594C10.3364 24.1323 10.8508 23.2602 11.2918 22.3431C11.3179 22.2894 11.293 22.2257 11.2398 22.2044C10.4239 21.8796 9.647 21.4835 8.89966 21.0337C8.84055 20.9975 8.83582 20.9087 8.8902 20.8663C9.04747 20.7426 9.20477 20.6139 9.35494 20.4839C9.38211 20.4602 9.41997 20.4552 9.45192 20.4702C14.3616 22.8229 19.6769 22.8229 24.5287 20.4702C24.5606 20.454 24.5985 20.459 24.6268 20.4827C24.7771 20.6126 24.9343 20.7426 25.0928 20.8663C25.1472 20.9087 25.1436 20.9975 25.0845 21.0337C24.3372 21.4922 23.5602 21.8796 22.7431 22.2032C22.6899 22.2244 22.6663 22.2894 22.6923 22.3431C23.1428 23.2589 23.6572 24.131 24.2236 24.9582C24.2473 24.9931 24.2898 25.0081 24.3289 24.9956C26.7802 24.1998 29.2658 22.999 31.8318 21.0212C31.8543 21.0037 31.8685 20.9775 31.8708 20.9488C32.4964 14.1568 30.8231 8.25706 27.4353 3.02694C27.427 3.00947 27.4128 2.99696 27.3963 2.98947ZM12.025 17.3704C10.5469 17.3704 9.32892 15.946 9.32892 14.1968C9.32892 12.4476 10.5233 11.0233 12.025 11.0233C13.5386 11.0233 14.7448 12.4601 14.7211 14.1968C14.7211 15.946 13.5268 17.3704 12.025 17.3704ZM21.9934 17.3704C20.5153 17.3704 19.2974 15.946 19.2974 14.1968C19.2974 12.4476 20.4917 11.0233 21.9934 11.0233C23.507 11.0233 24.7132 12.4601 24.6896 14.1968C24.6896 15.946 23.507 17.3704 21.9934 17.3704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1514_3090",
    x: 0,
    y: 0,
    width: 34,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.282353 0 0 0 0 0.435294 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1514_3090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1514_3090",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord-logo.02f4acdcca8bf4240f00e334042b500b.svg";
export { ForwardRef as ReactComponent };